import { Modal, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import AddEnpointForm from "../../../../../Components/Forms/AddEnpointForm"
import Icon from "../../../../../Icon"
import { addEndpoint } from "../../redux/publicApi.thunks"

const { Text } = Typography

const AddEndpointModal = ({ modalType, close, eventTypeOptions, onAddEnpointSuccess }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isMobile = useSelector((state) => state.nav.isMobile)

  const handleAddEnpoint = (data) => {
    dispatch(addEndpoint(data))
      .unwrap()
      .then(onAddEnpointSuccess)
      // The thunk already raised the global error notification; catching here only
      // keeps the rejection from surfacing as an unhandled promise rejection.
      .catch(() => {})
  }

  return (
    <Modal
      open={modalType?.type === "add_endpoint"}
      onClose={close}
      onCancel={close}
      footer={null}
      centered={true}
      closeIcon={<Icon type="cross_small" />}
      width={400}
      title={t("Add endpoint")}
      destroyOnClose
      className={isMobile ? "faq-custom-modal faq-custom-modal--mobile" : "faq-custom-modal"}
      classNames={{ content: "clear-bg" }}
    >
      <Text style={{ display: "block", margin: "10px 0 28px" }}>
        {t("Add an endpoint to start receiving webhook notifications for your selected events.")}
      </Text>

      <AddEnpointForm
        close={close}
        onSubmitAddEnpointForm={handleAddEnpoint}
        eventTypeOptions={eventTypeOptions}
      />
    </Modal>
  )
}

export default AddEndpointModal
